import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput,
  EditButton,
  ReferenceField
} from 'admin-on-rest/lib/mui';

import SubGenreInput  from '../custom/SubGenreInput';
import { DependentInput } from 'aor-dependent-input';
 
const DestinationFilter = (props) => (
  <Filter {...props}>

  <TextInput label="resources.type.name" source="modelo" alwaysOn/>
  <TextInput label="resources.sign.name" source="pinakida" alwaysOn/>

  <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty alwaysOn perPage={1000}>
  <SelectInput optionText={choice => `${choice.name}`} />
  </ReferenceInput>

  <ReferenceInput label="resources.branches.name" source="BranchID" reference="branches" allowEmpty alwaysOn perPage={1000}>
  <SelectInput optionText={choice => `${choice.address}`} />
  </ReferenceInput>

  </Filter>
);

export const OximataList = (props) => (
  <List {...props}  filters={<DestinationFilter />} title="resources.management_vehicles.name">
    <Datagrid>
    <TextField label="resources.type.name" source="modelo"/>
    <TextField label="resources.sign.name" source="pinakida" />
    <ReferenceField label="resources.companies.name" source="CompanyID" reference="companies">
         <TextField source="name" />
     </ReferenceField>
    <EditButton />
    </Datagrid>
  </List>
);

export const CreateOximata = (props) => (
  <Create title="Create vehicle" {...props}>
    <SimpleForm redirect="list">
    <TextInput label="resources.model.name" source="modelo"/>
    <TextInput label="resources.signl.name" source="pinakida" />

      <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty>
      <SelectInput optionText={choice => `${choice.name}`} />
      </ReferenceInput>

       <DependentInput dependsOn="CompanyID" >
       <TextField label="resources.branches.name" />
       <SubGenreInput />
      </DependentInput>



    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.modelo}` : ''}</span>;
};

export const EditOximata = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
    <TextInput label="resources.model.name" source="modelo"/>
    <TextInput label="resources.signl.name" source="pinakida" />
    <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty>
    <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>

    <DependentInput dependsOn="CompanyID" >
    <TextField label="resources.branches.name" />
    <SubGenreInput />
   </DependentInput>

    </SimpleForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
    return <span>{record ? `Delete of ${record.title}` : ''}</span>;
};

export const DeleteOximata = (props) => <Delete title={<DeleteTitle />} {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/oximatas.js